export const SERP_MONITORING_ERROR_MESSAGE = 'Something went wrong';
export const BLACKLIST_WORD_ALREADY_EXISTS = 'Blacklist word already exists';
export const SERP_MONITORING_SELECT_MARKET_AND_PRODUCT =
	'Select market and product';
export const SERP_MONITORING_ADD_TO_GRADE_LABEL = 'Add to grade';
